// Ordinance Setup Version 1
export const DEFAULT_REQUIREMENT_LEVEL = 50
export const DEFAULT_TARGET_SCORE_BASED_ON = 'percentage'